import * as apis from '../apis'

/**
 * 把共享的 vuex store 放到 kjqk-commons/src/common/micro-module.js
 * 以便于所有的子应用都能引用，并能单独启动项目
 */

export const microModule = {
  namespaced: true,
  state: {
    loginInfo: null,
    sites: [],
    siteId: '',
    navActive: '',
    versionInfo: {}, //版本信息
    firstGroupsIsSystem: false, // 判断菜单配置第一个页面是不是系统管理
    systemPreference: null // 平台偏好信息
  },
  getters: {},
  mutations: {
    /**
     * 保存登录接口数据
     * @param state
     * @param loginInfo
     * @constructor
     */
    SAVE_LOGIN_INFO(state, loginInfo) {
      // 定义需要按账号记忆清除的数据项
      const ACCOUNT_RELATED_STORAGE_KEYS = [
        'imgWatermarkSettingData', // 图片水印设置
        'localTakeNumpaperChecked', // 数字报选用是否勾选了带入数字报信息
        'visualStrategyAnalysisSettingData', // 生产库智能解析配置项
        'localCarryPaperInfo', //见报稿件选用是否勾选了带入报纸信息
        'wireHub_tree_article', // 新华社稿件线左侧树记忆
        'wireHub_tree_photo', // 新华社图片线左侧树记忆
        'wireHub_tree_video' // 新华社视频线左侧树记忆
      ]
      // 获取当前用户key
      const currentUserKey = loginInfo
        ? `${loginInfo.userCode}_${loginInfo.userID}`
        : null

      // 从localStorage获取上一次的用户key
      const lastUserKey = localStorage.getItem('lastUserKey')
      // 检查是否切换了用户
      const isDifferentUser =
        currentUserKey && lastUserKey && currentUserKey !== lastUserKey
      // 如果是不同用户，清除水印设置等按账号记忆的数据
      if (isDifferentUser) {
        try {
          ACCOUNT_RELATED_STORAGE_KEYS.forEach((key) => {
            localStorage.removeItem(key)
          })
        } catch (e) {
          console.warn('清除水印设置失败', e)
        }
      }
      // 保存当前用户key到localStorage
      if (currentUserKey) {
        localStorage.setItem('lastUserKey', currentUserKey)
      }

      state.loginInfo = loginInfo
      localStorage.setItem('loginInfo', JSON.stringify(loginInfo))
    },
    SET_NAV_IDS(state, { casId }) {
      if (casId) {
        state.navActive = casId
        sessionStorage.setItem('navActive', casId)
      }
    },
    SAVE_SITES(state, sites) {
      state.sites = sites
    },
    SET_SITE_ID(state, siteId) {
      state.siteId = siteId
    },

    SET_VERSION_INFO(state, versionInfo) {
      state.versionInfo = versionInfo
    },
    /**
     * 设置平台偏好信息
     * @param state
     * @param systemPreference
     * @constructor
     */
    SET_SYSTEM_PREFERENCE(state, systemPreference) {
      state.systemPreference = systemPreference
    }
  },
  actions: {
    async getVersion({ commit }) {
      const {
        data: { data }
      } = await apis.MediaCloudGateway.getDeplayVersion({})
      if (data) {
        window.localStorage.setItem('versionInfo', JSON.stringify(data))
      }
      commit('SET_VERSION_INFO', data)
    },
    /**
     * 获取站点列表
     * @param commit
     * @returns {Promise<*>}
     */
    async getSites({ commit }) {
      const {
        data: { data }
      } = await apis.MediaCloudSystemSite.getSites({})
      // console.log('sitesData', data)
      const sites = data.sites
      commit('SAVE_SITES', sites)
      return sites
    },
    /**
     * 获取当前站点id
     * @param state
     * @param commit
     * @param dispatch
     * @returns {Promise<*>}
     */
    async getSiteId({ state, commit, dispatch }) {
      // const sessionSiteId = sessionStorage.getItem('siteId')
      // if (sessionSiteId) {
      //   commit('SET_SITE_ID', +sessionSiteId)
      // }
      if (state.siteId) {
        return state.siteId
      }
      const sites = await dispatch('getSites')
      // console.log('sites', sites)
      if (sites && sites.length > 0) {
        const site = sites[0]
        commit('SET_SITE_ID', site.id)
        // sessionStorage.setItem('siteId', site.id)
        return site.id
      }
    },
    /**
     * 设置平台偏好信息
     * @param commit
     * @param systemPreference
     * @returns {*}
     */
    setSystemPreference({ commit }, systemPreference) {
      commit('SET_SYSTEM_PREFERENCE', systemPreference)
      return systemPreference
    }
  }
}
